// src/app/redux/reducers/campagnesReducer.js
import {
    FETCH_CAMPAGNES_REQUEST,
    FETCH_CAMPAGNES_SUCCESS,
    FETCH_CAMPAGNES_FAIL,

    FETCH_VISIBLE_CAMPAGNES_REQUEST,
    FETCH_VISIBLE_CAMPAGNES_SUCCESS,
    FETCH_VISIBLE_CAMPAGNES_FAIL,

    CREATE_CAMPAGNE_SUCCESS,
    CREATE_CAMPAGNE_FAIL,

    UPDATE_CAMPAGNE_SUCCESS,
    UPDATE_CAMPAGNE_FAIL,

    DELETE_CAMPAGNE_SUCCESS,
    DELETE_CAMPAGNE_FAIL,

    SET_CAMPAGNES_LOADING, FETCH_BUDGET_BY_CAMPAGNE_REQUEST, FETCH_BUDGET_BY_CAMPAGNE_SUCCESS,
} from "../actions/campagnesActions";

const initialState = {
    list: [],
    budgets: [],
    visibleList: [],

    loading: false,
    error: null,
    message: "",
};

export default function campagnesReducer(state = initialState, action) {
    switch (action.type) {
        case SET_CAMPAGNES_LOADING:
            return { ...state, loading: action.payload };

        case FETCH_CAMPAGNES_REQUEST:
        case FETCH_VISIBLE_CAMPAGNES_REQUEST:
            return { ...state, loading: true, error: null };

        case FETCH_CAMPAGNES_SUCCESS:
            return { ...state, list: action.payload || [], loading: false };

        case FETCH_BUDGET_BY_CAMPAGNE_REQUEST:
        case FETCH_BUDGET_BY_CAMPAGNE_SUCCESS:
            return { ...state, budgets: action.payload || [], loading: false };

        case FETCH_VISIBLE_CAMPAGNES_SUCCESS:
            return { ...state, visibleList: action.payload || [], loading: false };

        case FETCH_CAMPAGNES_FAIL:
        case FETCH_VISIBLE_CAMPAGNES_FAIL:
            return { ...state, loading: false, error: action.error || "Erreur" };

        case CREATE_CAMPAGNE_SUCCESS:
            return { ...state, list: [action.payload, ...state.list], loading: false };

        case UPDATE_CAMPAGNE_SUCCESS:
            return {
                ...state,
                list: state.list.map((c) => (c.id === action.payload.id ? action.payload : c)),
                loading: false,
            };

        case DELETE_CAMPAGNE_SUCCESS:
            return {
                ...state,
                list: state.list.filter((c) => c.id !== action.payload.id),
                loading: false,
            };

        case CREATE_CAMPAGNE_FAIL:
        case UPDATE_CAMPAGNE_FAIL:
        case DELETE_CAMPAGNE_FAIL:
            return { ...state, loading: false, error: action.error || "Erreur" };

        default:
            return state;
    }
}
